import { render, staticRenderFns } from "./PollForm.vue?vue&type=template&id=0b2af770&scoped=true&"
import script from "./PollForm.vue?vue&type=script&lang=ts&"
export * from "./PollForm.vue?vue&type=script&lang=ts&"
import style0 from "./PollForm.vue?vue&type=style&index=0&id=0b2af770&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b2af770",
  null
  
)

export default component.exports